<style lang="scss">

    #cart-popup-container{
        position:fixed;
        top:0;
        left:0;
        width:100%;
        height:100%;
        z-index:99999;
        pointer-events: none;
        overflow: auto;
        display: flex;
        align-items: center;
        justify-content: center;

        &.appear{
            pointer-events: all;
            transition: all 600ms;

            .background-obfuscator{
                opacity:1;
                transition: all 600ms;
            }

            .cart-popup{
               // top:50%;
                margin-top:20px;
                margin-bottom:20px;
                opacity: 1;
                transition: all 600ms;
                transition-delay: 400ms;
            }

        }

        .cart-popup{
            position: absolute;
           /* top:55%;
            left:50%;
            transform: translate(-50%, -50%);*/
            width: 90%;
            height:auto;
            display: flex;
            max-width: 850px;
            background: #1a1a1a;
            padding:20px;
            opacity:0;

            .product-line{
                max-width: 100%;
            }

            .all-list{
                margin-bottom:0px;
            }

            .owl-dots{
                display: flex !important;
                align-items: center;
                justify-content: center;
                margin-top:30px;

                @media(max-width: 575px) {
                    margin-top:10px;
                }

                .owl-dot{
                    border:1px solid transparent;
                    margin: 5px 12px;
                    padding:0px 3px;

                    span{
                        width: 8px;
                        height: 8px;
                        box-shadow:0px 0px 0px 1px rgba(255, 255, 255, 0.2);
                        background:transparent;
                        margin:0;
                    }

                    &.active{
                        border:1px solid rgba(255, 255, 255, 0.2);
                        box-shadow:0px 0px 0px 3px rgba(255, 255, 255, 0.05);
                        padding: 4px 4px !important;
                        border-radius: 25px;

                        span{
                            width: 10px;
                            height: 10px;
                            background:#c0a680;
                            border-color:#c0a680;
                        }

                    }

                }

            }

            @media (min-width: 768px) {
                .owl-item.active{

                    a{
                        .product-text{
                            opacity:.8;
                            transition: all 300ms;
                        }

                        &:hover{

                            .product-text{
                                opacity:1;
                                transition: all 300ms;
                            }

                        }
                    }

                    & > div {
                        position: relative;

                        &:after{
                            content:"";
                            position: absolute;
                            right:8px;
                            top:-3px;
                            width: 1px;
                            height:calc(100% + 6px);
                            background:rgba(255, 255, 255, 0.1);
                        }
                    }

                    & + .owl-item.active{

                        & > div {

                            @media(min-width: 992px) {
                                padding-left:28px !important;
                            }

                            &:after{
                                display:none;
                            }

                        }

                    }

                }
            }

            @media(min-width: 992px) {
                padding:30px 50px;
            }

            .form-submit{
                margin-top:0px;
                width: 100%;

                a{
                    width: 100%;
                    padding: 17px 25px 16px;
                    display: flex;
                    justify-content: center;
                }

            }

        }

        .background-obfuscator{
            position:fixed;
            left:0px;
            top:0;
            width: calc(100%);
            height:100%;
            background:rgba(0, 0, 0, 0.5);
            z-index:-1;
            opacity: 0;
            transition: all 600ms;
        }

        span.prodotto-price{
            color: #C0A680;
            display: inline-block;
            margin-left: auto;
        }

        .p-img{
            position: relative;
            max-width: 90px;
            object-fit: contain;

            @media (max-width: 575px){
                max-width: 65px;
            }

        }

        .other-products-text{

            @media (max-width:575px){
                font-size: 1.2rem;
                margin-bottom:0px;
            }

        }

        .close-preview{
            position:absolute;
            right:20px;
            top:20px;
            width:30px;
            height:30px;
            display:flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            z-index: 100;

            &:before{
                content: "";
                border-radius: 100%;
                border: 1px solid rgba(255, 255, 255, 0.4);
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                transition: all 200ms;
            }

            &:after{
                content: "";
                border-radius: 100%;
                border: 0 solid transparent;
                position: absolute;
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                transition: all 200ms;
            }

            &:hover{

                &:before{
                    content: "";
                    border-top-color: #ffffff;
                    border-right-color: #ffffff;
                    border-bottom-color: #ffffff;
                    transition: border-top-color 0.1s linear, border-right-color 0.1s linear 0.05s, border-bottom-color 0.1s linear 0.15s;
                }

                &:after{
                    content: "";
                    border-top: 1px solid #ffffff;
                    border-left-width: 1px;
                    border-right-width: 1px;
                    -webkit-transform: rotate(270deg);
                    transform: rotate(270deg);
                    transition: -webkit-transform 0.35s linear 0s;
                    transition: transform 0.35s linear 0s;
                    transition: transform 0.35s linear 0s, -webkit-transform 0.35s linear 0s;
                }

            }

        }

        .popup-text{
            font-style: italic;
            font-size:1.25rem;

            @media(max-width: 575px) {
                font-size:1rem;
            }

            span{
                white-space: initial;
            }
        }

        .product-text{
            font-size:1.1rem;

            @media(max-width: 575px) {
                font-size:.9rem;
            }

            & > span{
                white-space: initial;
            }

        }

        .prodotto-price{
            font-size:1.25rem;

            span{
                font-size: 13px;
                margin-right: 1px;
                display: inline-block;
                position: relative;
                top: -8px;
            }

        }

        .separate-border-bottom{
            position: relative;
            padding-bottom: 45px;

            &:after{
                content:"";
                position: absolute;
                bottom:0px;
                left:0%;
                width: 100%;

                @media(min-width: 992px) {
                    left:-3%;
                    width: 106%;
                }

                border-bottom:1px solid rgba(255, 255, 255, 0.2);
            }

        }

    }

</style>

<template>
    <div id="cart-popup-container" :class="{'appear' : show}">
        <div class="background-obfuscator" @click="closePopup"></div>

        <div class="cart-popup">
            <div class="close-preview" @click="closePopup">
                <img width="10" src="/img/frontend/x-01.svg" alt="chiudi"/>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-12 mb-2">
                        <div class="all-list">
                            <div class="w-100 d-flex product-line" v-if="typeof current_product != 'undefined'">
                                <img height="150" class="p-img mt-2" :src="current_product.options.image" :alt="current_product.options.name" />
                                <div class="flex-grow-1 pl-3 pl-md-4 pl-lg-5">
                                    <div class="cart-dati-1-note border-0 flex-grow-1 pl-0 pr-2 pr-md-5 pt-3 pb-0 w-100 popup-text">
                                        <span>{{$root.translateString('added_to_cart_popup')}}</span>
                                    </div>
                                    <div class="cart-dati-1-note border-0 flex-grow-1 pl-0 pt-4 pb-2 w-100 product-text">
                                        <span>{{current_qty}} x</span>
                                        <span>
                                            <span class="text-uppercase" v-text="current_product.options.name"></span>
                                            <span v-text="current_product.options.combination"></span>
                                        </span>
                                    </div>
                                    <div class="cart-dati-1-note py-0 flex-grow-1 pl-0">
                                        <span class="flex-grow-1 prodotto-price text-gold mb-4">
                                            <span class="euro">€</span> {{ $root.currencyDisplaySimple(parseFloat(current_product.price) * parseInt(current_qty)) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row separate-border-bottom mt-3">
                    <div class="col-12 col-md-6">
                        <div class="form-submit">
                            <a href="javascript:void(0)" @click="closePopup" :title="$root.translateString('continue_shopping_popup')">{{$root.translateString('continue_shopping_popup')}}</a>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 mt-4 mt-md-0">
                        <div class="form-submit">
                            <a href="/carrello" :title="$root.translateString('go_to_cart')" class="golden">{{$root.translateString('go_to_cart')}}</a>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-4 pt-2 text-center">
                        <h4 class="text-gold other-products-text">{{$root.translateString('you_could_be_interested_into')}}</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mt-sm-3 pt-2 text-center" v-if="current_id != null">

                        <carousel :autoplay="checkCount" :autoHeight="true" :autoplayHoverPause="true" playTimeout="5000" :loop="checkCount" :nav="false" :dots="true" :responsive="{0:{items:1},768:{items:2, dots:checkCount}}">

                            <div class="px-3 text-left d-block" v-for="(accessory, index) in filtered_accessories" :key="index">
                                <a :href="accessory.url_it" class="w-100 d-flex product-line text-decoration-none">
                                    <img height="110" class="p-img" :src="accessory.image" :alt="accessory.title" />
                                    <div class="flex-grow-1 pl-3">
                                        <div class="cart-dati-1-note border-0 flex-grow-1 pl-0 pt-3 pb-2 w-100 product-text">
                                            <span>
                                                <span class="text-uppercase" v-text="accessory.title"></span>
                                                <br>
                                                <span v-text="accessory.subtitle_it"></span>
                                            </span>
                                        </div>
                                        <div class="cart-dati-1-note py-0 flex-grow-1 pl-0 pt-2">
                                            <span class="flex-grow-1 prodotto-price mb-0 text-gold">
                                                <span class="euro">€</span> {{ $root.currencyDisplaySimple(parseFloat(accessory.price)) }}
                                            </span>
                                        </div>
                                    </div>
                                </a>
                            </div>

                        </carousel>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
import carousel from 'vue-owl-carousel'
export default {
    components: { 'carousel' : carousel },
    props: ['lang', 'accessories'],
    data() {
        return {
            show: false,
            cartRaw: null,
            missing_for_free_shipping: 0,
            current_product: {
                options:{
                    image: '',
                    name: ''
                },
            },
            current_qty: 0,
            current_id: null,
            current_code: null,
            filtered_accessories: [],
        }
    },
    mounted() {
        this.getCart();

        this.$eventHub.$on('cart.added', payload => {
            this.getCart();
            this.current_qty = payload.specific_count;
            this.current_id = payload.product_id;
            this.current_code = payload.product_code;
            this.openPopup();
            this.filteredAccessories();
        });
    },
    methods: {
        openPopup() {
            this.show = true;
            document.body.style.top = `-${window.scrollY}px`;
            //document.body.style.position = 'fixed';
            $('body').toggleClass('menu-open');
        },
        closePopup() {
            this.show = false;
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
            $('body').toggleClass('menu-open');
        },
        getCart() {
            axios.get('/api/cart/get')
            .then(response => {
                this.cartRaw = response.data.cart;
                this.shipping = response.data.shipping;
                this.priceTotalWt = response.data.priceTotalWt;
                this.discount = response.data.discount;
                this.missing_for_free_shipping = response.data.missingForFreeShipping;

                this.current_product = _.filter(this.cart, item => { return (item.id == this.current_id && item.options.code == this.current_code) })[0];

                if(_.isEmpty(this.cart)) {
                    this.show = false;
                }

            })
        },
        isNotEmpty(object) {
            return (_.isEmpty(object) === false);
        },
        filteredAccessories() {
            this.filtered_accessories = _.filter(this.accessories, obj => { return obj.id != this.current_id; })[0];
        },
    },
    beforeDestroy() {
        this.$eventHub.$off('cart.added');
    },
    computed: {
        cart() {
            if(this.cartRaw == null) {
                return null;
            }
            let tmp = {};
            for (const [key, value] of Object.entries(this.cartRaw)) {
                if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                    tmp[key] = value;
                }
            }
            return tmp;
        },
        checkCount() {
            if(this.filtered_accessories.length > 2) {
                return true;
            }else{
                return false;
            }
        },
    }
}
</script>
